export default __webpack_public_path__ + "assets/images/bcdc207f0f9f0c34f8e2913498d4bffb.png";